<template>
  <b-form class="search-box" inline @submit="doSearch">
    <b-form-input size="sm" type="text" placeholder="Search" v-model="q" autocomplete="off" />
    <font-awesome-icon icon="search" @click="doSearch"/>
  </b-form>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .search-box {
    position: relative;
    width: 100%;

    input {
      width: 100%;
      border-radius: 15px;
      background-color: $dark;
      border: none;
      opacity: 0.69;
      padding-left: 1em;
      padding-right: 2em;
      color: $white;

      &:focus {
        outline: none;
        border: none;
        box-shadow: none;
        background-color: $dark;
        color: $white;
      }
    }

    svg {
      position: absolute;
      right: 1em;
      opacity: 0.69;
      color: $white;
      cursor: pointer;
    }
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'SearchBox',
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      q: ''
    }
  },
  methods: {
    doSearch (ev) {
      ev.preventDefault()

      let q = this.q.trim()
      if (!q) return

      this.q = ''
      this.$emit('search', q)
      this.$router.push({name: 'discover-results', query: {q}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/SearchBox.vue